import React from 'react';
import { Paper, Box } from '@mui/material';
import QRCodeComponent from './QRCodeComponent';

interface PreviewPanelProps {
  qrText: string;
  sanitizedHtml: string;
}

const PreviewPanel: React.FC<PreviewPanelProps> = ({
  qrText,
  sanitizedHtml,
}) => {
  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Box
        display="grid"
        gridTemplateColumns={{ xs: '1fr', md: '1fr 1fr' }}
        gap={2}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <QRCodeComponent text={qrText} />
        </Box>
        <Box sx={{ wordWrap: 'break-word' }}>
          <div className="preview-html" dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
        </Box>
      </Box>
    </Paper>
  );
};

export default PreviewPanel;
